import { useQuery } from '@apollo/client'
import { EmploymentAnswer } from 'candidate/components/EmploymentQuestion'
import { CurrentIntakeQuery } from 'candidate/graphql/candidateIntakes.gql'
import { CandidateIntake } from 'candidate/models/intake'
import React, { useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { LoadingPanel } from 'shared/components/LoadingPanel'
import useToast from 'shared/components/Toast/useToast'
import { usePageTitle } from 'shared/hooks/usePageTitle'
import { commonRouteConfig } from 'shared/routeConfig'
import { deleteToken } from 'shared/utils/auth'
import ActiveQuestion from './ActiveQuestions'

function normalizeDate(date: string | null | undefined): string {
    if (!date) return ''
    return date
}

const Questions: React.FC = () => {
    usePageTitle('Intake')
    const toast = useToast()
    const navigate = useNavigate()
    const { candidateIntakeId } = useParams<{
        candidateIntakeId: ''
    }>()

    const [currentIntake, setCurrentIntake] = useState<
        Partial<CandidateIntake>
    >({} as CandidateIntake)
    const [currentWorkExperience, setCurrentWorkExperience] =
        useState<any>(null)
    const { loading } = useQuery(CurrentIntakeQuery, {
        variables: { candidateIntakeId },
        onCompleted: (data) => {
            setCurrentIntake(data.currentIntake)
            setCurrentWorkExperience(
                data.currentIntake?.candidate?.currentWorkExperience ?? null
            )

            if (!data.currentIntake) {
                console.log('invalid candidate intake')
                // TODO: more detailed error message?
                toast({
                    title: 'Something went wrong',
                    message: 'Please try again',
                })
                deleteToken()
                return navigate(commonRouteConfig.login.path, { replace: true })
            }
        },
    })

    const existingEmploymentAnswer: EmploymentAnswer | undefined =
        useMemo(() => {
            if (!currentWorkExperience) return undefined
            const cwe = currentWorkExperience
            return {
                company: cwe.company
                    ? { choice: cwe.company.value, id: cwe.company.id }
                    : undefined,
                companyOffice: cwe.companyOffice?.officeLocation
                    ? { choice: cwe.companyOffice.officeLocation.value }
                    : undefined,
                workTitle: cwe.title?.value ?? '',
                startDate: normalizeDate(cwe.startDate),
                endDate: '',
                industries: cwe.industries?.map((i: any) => ({
                    choice: i.industry.value,
                })),
                sectors: cwe.sectors?.map((s: any) => ({
                    choice: s.sector.value,
                })),
                workEmail: cwe.workEmail ?? '',
                workPhone: cwe.workPhone ?? '',
            }
        }, [currentWorkExperience])

    if (loading) return <LoadingPanel />

    return (
        <ActiveQuestion
            candidateIntake={currentIntake}
            existingEmploymentAnswer={existingEmploymentAnswer}
            existingWorkExperienceId={currentWorkExperience?.id}
        />
    )
}

export default Questions
